import React from 'react';
import { RunStatus } from '../../types';

interface StatusBadgeProps {
  status: RunStatus;
}

export const STATUS_LABELS: Record<RunStatus, string> = {
  pending: 'Pending',
  ray_running: 'Ray Running',
  ray_completed: 'Ray Completed',
  pc_running: 'PC Running',
  completed: 'Completed',
  outdated: 'Outdated',
  failed: 'Failed',
  cancelled: 'Cancelled',
  timed_out: 'Timed Out',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return (
    <span className="eval-status-badge" data-status={status}>
      {STATUS_LABELS[status]}
    </span>
  );
};
